module.exports = __webpack_public_path__ + "static/lights24-a6d81acfba9b7988b5d10f7141f7059c.jpg";